/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const usePriceItemStyles = makeStyles(theme => ({
  heading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: '12px',
    lineHeight: '15px',
    textTransform: 'uppercase',
    margin: '17px 0',
  },
  price: {
    color: theme.palette.primary.main,
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 500,
    cursor: 'pointer',
    textTransform: 'none',
    '&:hover': {
      color: theme.palette.tertiary.main,
    },
  },
  total: {
    position: 'relative',
    color: theme.palette.primary.main,
    fontSize: '20px',
    lineHeight: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontWeight: 500,
    paddingTop: '25px',
    marginTop: '20px',

    '&:before': {
      content: "''",
      position: 'absolute',
      display: 'block',
      top: 0,
      left: 0,
      right: '100%',
      width: '100%',
      height: '1px',
      background: '#F6F7F8',
      borderRadius: '0.5px',
    },

    '& $price': {
      fontSize: 'inherit',
      lineHeight: 'inherit',
      color: 'inherit',
    },
  },
}));
